<template>
  <div class="liveness container">
    <div class="top">
      <div class="code">
        <div class="code-title">
          <span>请牢记以下验证码</span>
        </div>
        <div class="code-top">
          <span>用普通话朗读，视频时长3-8秒最佳</span>
        </div>
        <div class="code-code">
          <div class="code-text" v-for="(item, index) in codeArr" :key="index">
            <span>{{ item }}</span>
          </div>
        </div>
        <div class="code-tips">
          <span>请正视手机，保证光线充足</span>
        </div>
        <div class="code-tips">
          <span>请勿遮挡面部</span>
        </div>
      </div>
    </div>
    <div class="text">
      <div>
        <span>①.牢记验证码，点击开始录制</span>
      </div>
      <div>
        <span>②.开启前置摄像头，用普通话朗读数字</span>
      </div>
      <div>
        <span>③.完成录制，等待验证结果</span>
      </div>
    </div>
    <div class="button-list">
      <mt-button type="primary" size="large" @click="handleStartTap">开始录制</mt-button>
    </div>
    <!-- user camcorder -->
    <input id="video1" type="file" accept="video/*" capture="user" style="display:none;" @change="handleFileChange" />
  </div>
</template>

<script>
import { RecordThridSpendLog } from '@/api/customer';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusAlert, CusConfirm, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { upLoadImgForAgent } from '@/utils/utils';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'XwpVideoLiveness',
  data() {
    return {
      code: '',
      codeArr: [],
      session_id: '',
    };
  },
  computed: {
    ...mapGetters(['livingFaceAccessToken', 'livingFaceCustomerId', 'livingFaceVerifyType']),
  },
  methods: {
    ...mapMutations(['setLivingFaceImgUrl', 'setLivingFacePopupStatus', 'setLivingFaceType']),

    // 调用接口，计费统计
    recordThridSpendLog(type, callback = null) {
      const data = {
        customerId: this.livingFaceCustomerId,
        payType: 4,
        type: type,
      };
      RecordThridSpendLog(data)
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },

    drawBaiduSessionCode() {
      CusLoadingOpen();
      this.recordThridSpendLog(5, () => {
        this.$axios({
          url: `https://aip.baidubce.com/rest/2.0/face/v1/faceliveness/sessioncode?access_token=${this.livingFaceAccessToken}`,
          data: 'min_code_length=4&max_code_length=4',
          method: 'post',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        })
          .then(res => {
            CusLoadingClose();
            if (res.data.error_code === 0) {
              this.code = res.data.result.code;
              this.codeArr = res.data.result.code.split('');
              this.session_id = res.data.result.session_id;
            } else {
              this.$emit('openImageLiveness');
            }
          })
          .catch(() => this.$emit('openImageLiveness'));
      });
    },

    startBaiduFaceLiveness() {
      const that = this;
      CusLoadingOpen('人脸识别进行中…');
      that.recordThridSpendLog(6, () => {
        const file = document.getElementById('video1').files[0];
        const reader = new FileReader();
        reader.onload = function () {
          const formData = new FormData();
          formData.append('session_id', that.session_id);
          formData.append('video_base64', this.result.split(',')[1]);
          that
            .$axios({
              url: `https://aip.baidubce.com/rest/2.0/face/v1/faceliveness/verify?access_token=${that.livingFaceAccessToken}`,
              data: formData,
              method: 'post',
              headers: { 'Content-Type': 'multipart/form-data' },
            })
            .then(res => {
              CusLoadingClose();
              if (res.data.error_code === 0) {
                const score = res.data.result.score; // 活体分数
                const thresholds = res.data.result.thresholds['frr_1e-3']; // 活体阈值
                const similarity = res.data.result.code.similarity; // 语音相似度
                const condition1 = score > thresholds; // 合格条件1：活体分数大于阈值，合格
                const condition2 = similarity > 0.75; // 合格条件2：语音相似度大于0.75，合格
                if (condition1 && condition2) {
                  const pic = res.data.result.pic_list[0].pic;
                  upLoadImgForAgent(
                    null,
                    pic,
                    'renLian',
                    res => {
                      CusLoadingClose();
                      if (res.code === 0) {
                        that.setLivingFacePopupStatus(false);
                        that.setLivingFaceImgUrl(res.data);
                        that.setLivingFaceType(1);
                      } else {
                        CusConfirm(
                          '图片上传接口出错了<br />是否使用照片活体检测？',
                          () => {
                            that.setLivingFacePopupStatus(false);
                            that.$emit('openImageLiveness');
                          },
                          () => that.setLivingFacePopupStatus(false)
                        );
                      }
                    },
                    () => {
                      CusLoadingClose();
                      CusConfirm(
                        '无法连接图片服务器<br />是否使用照片活体检测？',
                        () => {
                          that.setLivingFacePopupStatus(false);
                          that.$emit('openImageLiveness');
                        },
                        () => that.setLivingFacePopupStatus(false)
                      );
                    }
                  );
                } else {
                  if (!condition1) {
                    if (that.livingFaceVerifyType === 1) {
                      CusConfirm(
                        `分数:${score}，阈值:${thresholds}<br />分数小于阈值，不合格<br />是否使用照片活体检测？`,
                        () => {
                          that.setLivingFacePopupStatus(false);
                          that.$emit('openImageLiveness');
                        },
                        () => that.setLivingFacePopupStatus(false)
                      );
                    }
                    if (that.livingFaceVerifyType === 2) {
                      CusAlert(`分数:${score}，阈值:${thresholds}<br />分数小于阈值，不合格，请重新录制视频`, () => that.setLivingFacePopupStatus(false));
                    }
                  }
                  if (!condition2) {
                    if (that.livingFaceVerifyType === 1) {
                      CusConfirm(
                        `语音相似度:${similarity}，小于0.75，不合格<br />是否使用照片活体检测？`,
                        () => {
                          that.setLivingFacePopupStatus(false);
                          that.$emit('openImageLiveness');
                        },
                        () => that.setLivingFacePopupStatus(false)
                      );
                    }
                    if (that.livingFaceVerifyType === 2) {
                      CusAlert(`语音相似度:${similarity}，小于0.75，不合格<br />请重新录制视频`, () => that.setLivingFacePopupStatus(false));
                    }
                  }
                }
              } else {
                that.showFaceFailInfo(res.data.error_code);
              }
            })
            .catch(() => {
              CusLoadingClose();
              if (that.livingFaceVerifyType === 1) {
                CusAlert('视频活体检测出错了<br />请使用照片活体检测', () => {
                  that.setLivingFacePopupStatus(false);
                  that.$emit('openImageLiveness');
                });
              }
              if (that.livingFaceVerifyType === 2) {
                that.setLivingFacePopupStatus(false);
                that.setLivingFaceImgUrl('living face error');
              }
            });
        };
        reader.readAsDataURL(file);
      });
    },

    handleStartTap() {
      document.getElementById('video1').click();
    },

    handleFileChange(e) {
      if (!e.target.value) return;
      this.startBaiduFaceLiveness();
    },

    showFaceFailInfo(errCode) {
      let content = '';
      switch (errCode) {
        case 216430:
          content = 'rtse/face 服务异常，请重新录制视频';
          break;
        case 216431:
          content = '语音识别服务异常，请重新录制视频';
          break;
        case 216432:
          content = '视频解析服务调用失败，请重新录制视频';
          break;
        case 216433:
          content = '视频解析服务发生错误，请重新录制视频';
          break;
        case 216434:
          content = '活体检测失败，请重新录制视频';
          break;
        case 216500:
          content = '验证码位数错误，请重新录制视频';
          break;
        case 216501:
          content = '没有找到人脸，请重新录制视频';
          break;
        case 216502:
          content = '当前会话已失效，请重新录制视频';
          break;
        case 216505:
          content = 'redis连接失败，请重新录制视频';
          break;
        case 216506:
          content = 'redis操作失败，请重新录制视频';
          break;
        case 216507:
          content = '视频中有多张人脸，请重新录制视频';
          break;
        case 216508:
          content = '没有找到视频信息，请重新录制视频';
          break;
        case 216509:
          content = '视频中的声音无法识别，请重新录制视频';
          break;
        case 216908:
          content = '视频中人脸质量过低，请重新录制视频';
          break;
        case 222027:
          content = '验证码长度错误，请重新录制视频';
          break;
        case 222028:
          content = '参数格式错误，请重新录制视频';
          break;
        case 222029:
          content = '参数格式错误，请重新录制视频';
          break;
        case 222030:
          content = '参数格式错误，请重新录制视频';
          break;
        default:
          content = `错误，错误码${errCode}，请重新录制视频`;
          break;
      }
      if (this.livingFaceVerifyType === 1) {
        CusConfirm(
          `${content}<br />是否使用照片活体检测？`,
          () => {
            this.setLivingFacePopupStatus(false);
            this.$emit('openImageLiveness');
          },
          () => this.setLivingFacePopupStatus(false)
        );
      }
      if (this.livingFaceVerifyType === 2 || this.livingFaceVerifyType === 3) {
        CusAlert(`${content}`, () => this.setLivingFacePopupStatus(false));
      }
    },
  },
};
</script>
